export const PROFILE_PAGE_SIZE = 10;
export const PROFILE_PAGE_SIZE_OPTIONS = ['10', '20', '30'];

export const ERROR_MESSAGES = {
  FETCH_PROFILES_FAILED: 'Profile data could not be loaded.',
  CREATE_PROFILE_FAILED: 'Unable to create profile. Please try again.',
  ADD_JOB_CODE_FAILED: 'Unable to add job code. Please try again.',
  FETCH_ENTITLEMENTS_FAILED: 'Entitlement data could not be loaded.',
  UPDATE_ENTITLEMENTS_FAILED: 'Unable to update entitlements. Please try again.',
  PROFILE_NAME_REQUIRED: 'Please enter a profile name.',
};

export const WARNING_TITLES = {
  FETCH_PROFILES: 'Profile Data Unavailable',
  FETCH_ENTITLEMENTS: 'Entitlement Data Unavailable',
};

export const ERROR_TITLES = {
  CREATE_PROFILE: 'Unable to Create Profile',
  UPDATE_ENTITLEMENTS: 'Unable to Update Entitlements',
};

export const getApiErrorMessage = (error, fallbackMessage) => {
  return fallbackMessage;
};
